import React from 'react';
import t from '@rcm/i18n-client';
import { Button, FieldRendererIntersectionProps, FieldType, Modal } from 'forms';
import noop from 'lodash/noop';

interface Props<
    Value extends any,
    E extends HTMLElement,
    P extends object
> {
    disabled?: boolean;
    field: FieldType<Value, E, P>;
    fieldProps: FieldRendererIntersectionProps<Value, E> & P;
    head?: React.ReactNode;
    isOpen?: boolean;
    onCancel?: () => void;
    onSubmit?: () => void;
    onValueChange?: (value: Value) => void;
    submitOnChange?: boolean;
    value: Value;
}

const EditorModal = <
    Value extends any,
    E extends HTMLElement,
    P extends object
>({
    disabled,
    field: Field,
    fieldProps,
    head,
    isOpen = false,
    onCancel,
    onSubmit,
    onValueChange = noop,
    submitOnChange = false,
    value,
}: Props<Value, E, P>) => <Modal
    className="editor"
    head={head}
    foot={(!submitOnChange) ?
        <>
            <Button btn="default"
                disabled={disabled}
                text={t('Cancel')}
                onClick={onCancel} />
            <Button btn="primary"
                disabled={disabled}
                className="pull-right"
                text={t('Save')}
                onClick={onSubmit} />
        </> :
        <Button btn="default"
            disabled={disabled}
            text={t('Cancel')}
            onClick={onCancel} />
    }
    show={isOpen}
    onClose={onCancel}
>
    <Field value={value}
        onValueChange={onValueChange}
        disabled={disabled}
        {...fieldProps} />
</Modal>;

export default EditorModal;
